module.exports = __webpack_public_path__ + "src/assets/img/page9/b2402cfc11d8ecaa87abe1f27f5f8c4b.jpg";